export default __webpack_public_path__ + "static/media/Sophos.ac2a23bd.png";